export default (params) => ({
  trigger: {
    name: 'filter_and_sort.close_overlay',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'filter_and_sort_overlay',
          'highlights_overlay',
          'employee_atc_page',
          'employee_ato_page',
          'customer_atc_page',
          'business_atc_page',
          'upsell_filter',
        ],
      },
    },
    event: {
      name: 'close',
    },
    nonInt: false,
  },
});
